// src/pages/History/MedievalHistory/MedievalEuropeGo.jsx
import React from 'react';
import QuizPage from '../../../components/QuizPageNew2';
import bg from '../../../assets/history2/Middle_Ages_-_Medieval_Europe.png';

function HistoryPageMedievalGo() {
  return (
    <QuizPage
      title="History: Medieval Europe"
      subTopic="Medieval Europe"
      backgroundImage={bg}
      returnPath="/History-Medieval-Europe"
    />
  );
}

export default HistoryPageMedievalGo;   